var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMastercard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 31",
    style: {
      enableBackground: "new 0 0 46 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n\t.st1{fill:#FD5F01;}\n\t.st2{fill:#E9011B;}\n\t.st3{fill:#F59C1C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,0.4h40c1.7,0,3,1.3,3,3v24.1c0,1.7-1.3,3-3,3H3c-1.7,0-3-1.3-3-3V3.5C0,1.8,1.3,0.4,3,0.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23,23.5c4.4-3.5,5.2-9.9,1.7-14.3C24.2,8.6,23.6,8,23,7.5l0,0c-4.4,3.5-5.2,9.9-1.7,14.3 C21.8,22.4,22.4,23,23,23.5L23,23.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.1,15.5c0-3.1,1.4-6.1,3.9-8C18.6,4,12.2,4.8,8.7,9.2S5.9,20,10.3,23.5c3.7,2.9,8.9,2.9,12.7,0 C20.5,21.6,19.1,18.6,19.1,15.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.5,15.5c0,5.6-4.6,10.2-10.2,10.2c-2.3,0-4.5-0.8-6.3-2.2c4.4-3.5,5.2-9.9,1.7-14.3C24.2,8.6,23.6,8,23,7.5 C27.4,4,33.8,4.8,37.3,9.2C38.7,11,39.5,13.2,39.5,15.5L39.5,15.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMastercard);
export default __webpack_public_path__ + "static/media/ic_mastercard.19f969a54eda57d8ecc11ef8aa859d57.svg";
export { ForwardRef as ReactComponent };